/**
 * IconGallery.jsx - IconGallery - Icon picker with customizable gallery
 * 
 * CHANGE HISTORY:
 * - 251018_1327 [43ebfec] danielbeer: refactor: restructure packages - extract all nested packages to top level
 */
import React, { useState } from 'react';

const DEFAULT_ICONS = [
  '📋', '📝', '✅', '❌', '⭐', '🎯', '🔥', '💡', '🚀', '⚡',
  '📊', '📈', '📉', '💰', '🎨', '🎭', '🎪', '🎬', '🎮', '🎲',
  '🏆', '🏅', '🎖️', '🏁', '🚩', '🎌', '🏴', '🏳️', '🏴‍☠️', '🏳️‍🌈',
  '🔴', '🟠', '🟡', '🟢', '🔵', '🟣', '🟤', '⚫', '⚪', '🟥',
  '🟧', '🟨', '🟩', '🟦', '🟪', '🟫', '⬛', '⬜', '◼️', '◻️',
  '▪️', '▫️', '●', '○', '■', '□', '▲', '△', '▼', '▽',
  '◆', '◇', '★', '☆', '✦', '✧', '✨', '⭐', '🌟', '💫'
];

const IconGallery = ({ onClose, onSelect }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [customIcons, setCustomIcons] = useState([]);
  
  // Load custom icons from localStorage
  React.useEffect(() => {
    const saved = localStorage.getItem('organizr-custom-icons');
    if (saved) {
      try {
        setCustomIcons(JSON.parse(saved));
      } catch (error) {
        console.error('Failed to load custom icons:', error);
      }
    }
  }, []);
  
  const allIcons = [...DEFAULT_ICONS, ...customIcons];
  
  const filteredIcons = searchQuery
    ? allIcons.filter(icon => icon.includes(searchQuery))
    : allIcons;
  
  const handleAddCustomIcon = () => {
    const icon = prompt('Enter an emoji or character:');
    if (icon) {
      const updated = [...customIcons, icon];
      setCustomIcons(updated);
      localStorage.setItem('organizr-custom-icons', JSON.stringify(updated));
    }
  };
  
  return (
    <div className="organizr-modal-overlay" onClick={onClose}>
      <div className="organizr-modal icon-gallery-modal" onClick={(e) => e.stopPropagation()}>
        <div className="organizr-modal-header">
          <h3>Icon Gallery</h3>
          <button onClick={onClose} className="btn-modal-close">×</button>
        </div>
        
        <div className="organizr-modal-body">
          <div className="icon-gallery-search">
            <input
              type="text"
              placeholder="Search icons..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="icon-search-input"
            />
            <button onClick={handleAddCustomIcon} className="btn-add-custom-icon">
              + Add Custom
            </button>
          </div>
          
          <div className="icon-gallery-grid">
            {filteredIcons.map((icon, index) => (
              <button
                key={index}
                className="icon-gallery-item"
                onClick={() => onSelect(icon)}
                title={icon}
              >
                {icon}
              </button>
            ))}
          </div>
          
          {filteredIcons.length === 0 && (
            <div className="icon-gallery-empty">
              <p>No icons found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IconGallery;
